export default __webpack_public_path__ + "static/media/TRUCK14.7ae883cc.jpg";